<div class="orders-widget">
	<app-orders [widget]="widget()" />
</div>
